var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.65 566.93",
    style: {
      enableBackground: "new 0 0 566.65 566.93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A2527;}\n\t.st1{fill:#E84529;}\n\t.st2{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.53,
    className: "st0",
    width: 569.9,
    height: 566.93
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 282.42,
    cy: 289.05,
    r: 262.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.42,441.48c42.87,0,80.65,21.8,102.86,54.91h119.36L282.42,15.27L60.2,496.39h119.36 C201.78,463.28,239.55,441.48,282.42,441.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.52,349.7c-28.6-34.15-67.36-55.14-110.1-55.14c-42.74,0-81.5,21-110.1,55.1c-2.33,2.79-2.33,6.7,0,9.49 c28.6,34.15,67.36,55.14,110.1,55.14c42.74,0,81.5-21,110.1-55.1C394.85,356.4,394.85,352.5,392.52,349.7z M291.87,399.52 c-29.42,4.95-56.86-12.38-61.29-38.71s15.84-51.67,45.26-56.62c29.42-4.95,56.86,12.38,61.29,38.71 C341.55,369.23,321.29,394.58,291.87,399.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b54ce196.svg";
export { ForwardRef as ReactComponent };